import React from 'react';
import { Button } from '@asigna/kit';
import { ModalCloseButton } from 'components';
import { useProPage } from 'pages/ProPage/util/useProPage';

import { PeriodButton } from '../PeriodButton';

interface TransactionCommonProps {
  selectedPeriod: string;
  setSelectedPeriod: (period: string) => void;
  onClose: () => void;
  onSuccess: () => void;
}

export const ExtendSubscriptionDialog: React.FC<TransactionCommonProps> = ({
  selectedPeriod,
  setSelectedPeriod,
  onClose,
  onSuccess,
}) => {
  const { periodOptions } = useProPage();

  return (
    <div className="flex flex-col gap-32">
      <div className="flex items-center justify-between">
        <p className="text-r20">Extend Subscription</p>
        <ModalCloseButton onClick={onClose} />
      </div>

      <div className="flex w-full flex-col gap-24">
        <div className="grid grid-cols-2 gap-8">
          {periodOptions?.map((period, index) => (
            <PeriodButton
              key={period.title}
              title={period.title}
              price={period.price}
              fullPrice={period.fullPrice}
              discount={period.discount}
              isLast={index === periodOptions.length - 1}
              isSelected={period.title === selectedPeriod}
              onClick={() => setSelectedPeriod(period.title)}
            />
          ))}
        </div>
      </div>

      <div className="flex items-center gap-16 w-full">
        <Button message="Next" colorType="primary" fullWidth onClick={onSuccess} />
      </div>
    </div>
  );
};
